var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgXmlIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7673_1381)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3594 3.7207V14.2676C13.3594 14.4618 13.2822 14.6481 13.1449 14.7855C13.0075 14.9228 12.8212 15 12.627 15H2.37305C2.1788 15 1.9925 14.9228 1.85515 14.7855C1.71779 14.6481 1.64062 14.4618 1.64062 14.2676V0.732422C1.64062 0.538172 1.71779 0.351877 1.85515 0.214521C1.9925 0.0771657 2.1788 0 2.37305 0L9.63867 0L13.3594 3.7207Z",
    fill: "#41A5EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2676 7.03125H0.732422C0.327916 7.03125 0 7.35917 0 7.76367V12.1582C0 12.5627 0.327916 12.8906 0.732422 12.8906H14.2676C14.6721 12.8906 15 12.5627 15 12.1582V7.76367C15 7.35917 14.6721 7.03125 14.2676 7.03125Z",
    fill: "#0077CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3594 3.71953H9.63989V0L13.3594 3.71953Z",
    fill: "#D8EFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.42358 11.978L4.20552 9.80654L3.45845 7.94385H4.30015L4.74341 9.03457L5.102 7.94385H5.8438L5.13687 10.0406L5.92378 11.978H5.08706L4.5937 10.7728L4.16011 11.978H3.42358Z",
    fill: "#D8EFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.23755 11.978L6.30728 7.94385H7.26353L7.70679 10.2896L8.18491 7.94385H9.1063L9.17602 11.978H8.54351L8.4688 9.29355L8.00005 11.978H7.43784L6.93979 9.27363L6.8812 11.978H6.23755Z",
    fill: "#D8EFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.75842 11.978V7.94385H10.6499V11.3754H11.5763V11.978H9.75842Z",
    fill: "#D8EFFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7673_1381"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXmlIcon);
export default __webpack_public_path__ + "static/media/xml-icon.a13e68d0141c8e4a49bf2b4ae350dc82.svg";
export { ForwardRef as ReactComponent };